import { render, staticRenderFns } from "./LeftSideLogin.vue?vue&type=template&id=5d284b74&scoped=true"
import script from "./LeftSideLogin.vue?vue&type=script&lang=js"
export * from "./LeftSideLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d284b74",
  null
  
)

export default component.exports